import gql from "graphql-tag";

export const ADD_FAVORITE = gql`
  mutation addFavorite($programInfo: JSON!) {
    addFavorite(programInfo: $programInfo) {
      body
    }
  }
`;

export const GET_FAVORITES = gql`
  query getFavorites {
    getFavorites {
      body
    }
  }
`;

export const REMOVE_FAVORITE = gql`
  mutation removeFavorite($programInfo: JSON!) {
    removeFavorite(programInfo: $programInfo) {
      body
    }
  }
`;

export const UPDATE_FAVORITE = gql`
  mutation updateFavorite($programInfo: JSON!) {
    updateFavorite(programInfo: $programInfo) {
      body
    }
  }
`;
